import * as dc from "@/components/layout/list/defaultType";
import { DataListParams, DataListProp } from "../../layoutType";
import { getFormDateDiff } from "../../input/inputFunction";
import dayjs from "dayjs";
import { qcCommonCols, qcCommonInit } from "../../inputCols/qcCols";
import { beaninfoGreenbeanCol, beaninfoGreenbeanList, beaninfoLossCols, beaninfoNameCols } from "../../inputCols/beaninfoCols";
import { enLocale } from "@/i18n/routing";
export const CafeBeanInfo = (props: DataListProp): DataListParams | undefined => {
  const t = props.t;
  const ta = props.ta;
  const result = props.result;
  const params = props.params;
  const form = props.form;
  const formMemo = props.formMemo;
  const setValueList = props.setValueList;
  const formFunction = props.formFunction;
  const dataFunction = props.dataFunction;
  const alertContext = props.alertContext;

  const utcOffset = dayjs().utcOffset() * 60000;

  switch (params?.page.page ?? "") {
    //--info--{
    //--info--"table":{"system_TABLE_SCHEMA":"clm_roaster","system_TABLE_NAME":"roaster_user","system_table_pk":["roaster_seq","roaster_user_seq"],"system_table_page":"RoasterUser","system_table_path":"roaster/user/list","system_table_page_name":"RoasterUser","system_table_auth":["SADMIN","ADMIN","USER"],"system_select_auth":["roaster"],"system_roaster_auth":"SMNG","system_table_mapper":"roasteruser","system_table_detail_result":"detail_result","system_table_search_column":["roaster_user_auth","roaster_user_use"],"system_table_search_select":["roaster_user_name","roaster_user_nick"],"system_table_order_column":["roaster_user_auth","roaster_user_nick","roaster_user_name","rgst_at"],"system_table_default_name_column":"roaster_user_name","system_table_use_column":"roaster_user_use"}
    //--info--}
    case "CafeBeanInfo":
      return {
        ...result,
        dataFetch: { fetchUrl: "/api/cafe/beaninfo/default" },
        dataResultName: "detail_result",
        dataName: "CafeBeanInfo",
        useDefaultId: false,
        editCheck: true,
        useList: false,
        dataInit: (data: any) => {
          qcCommonInit(data, form?.current, formMemo?.current, formFunction?.current, dataFunction?.current);
        },
        dataCols: {
          blending_uuid_str: {
            ...dc.inputFull,
            label: "product_serial",
            labelClassName: dc.strongLabelClassName,
          },
          blending_register_link: {
            ...dc.link,
            fieldId: "blending_uuid_str",
            linkOption: { pathname: "/cafe/coffeebean/qrdefault/" },
            checkUserAuth: { cafe: ["BARISTA", "SAST", "MNG", "SMNG", "OWN"] },
          },
          ...beaninfoNameCols(form, formFunction?.current, params?.locale),
          greenbean_seq: beaninfoGreenbeanCol(form, formFunction?.current, params?.locale),
          blending_greenbean_list_show: beaninfoGreenbeanList(params?.locale),
          div_1: { ...dc.itemDiv, read: { display: "notNull", displayCheckIds: ["blending_desc"] } },
          blending_desc: {
            ...dc.textAreaU,
            labelUse: false,
            valueStyle: { gridColumn: "1 / span 2" },
            display: "notNull",
          },
          ...qcCommonCols(
            form,
            formFunction?.current,
            dataFunction?.current,
            params?.locale,
            [params?.locale === enLocale ? "blending_name" : "blending_name_locale"],
            alertContext,
            ta,
          ),
        },
        listColLinkField: ["blending_uuid"],
        base64Field: ["blending_uuid"],
        // dataReloadButton: false,
        undoButton: false,
        cancelButton: false,
        removeButton: false,
      };

    case "CafeBeanDetail":
      return {
        ...result,
        dataFetch: { fetchUrl: "/api/cafe/beaninfo/detail" },
        dataResultName: "detail_result",
        dataName: "CafeBeanDetail",
        useDefaultId: false,
        editCheck: true,
        useList: false,
        dataInit: (data: any) => {
          qcCommonInit(data, form?.current, formMemo?.current, formFunction?.current, dataFunction?.current);
          if (form?.current?.getFieldValue("blending_result_date")) {
            form?.current?.setFieldValue("cupnote_date", dayjs());
            form?.current?.setFieldValue("brewing_date_term", getFormDateDiff(form?.current, "blending_result_date", "cupnote_date"));
          }
        },
        dataCols: {
          blending_result_uuid: {
            ...dc.inputFull,
            fieldId: "blending_result_uuid_str",
            label: "product_serial",
            labelClassName: dc.strongLabelClassName,
          },
          blending_register_link: {
            ...dc.link,
            fieldId: "blending_result_uuid_str",
            linkOption: { pathname: "/cafe/coffeebean/qrreceived/" },
            checkUserAuth: { cafe: ["BARISTA", "SAST", "MNG", "SMNG", "OWN"] },
          },
          ...beaninfoNameCols(form, formFunction?.current, params?.locale, true),
          ...beaninfoLossCols,
          blending_greenbean_list_show: beaninfoGreenbeanList(params?.locale),
          div_1: { ...dc.itemDiv, read: { display: "notNull", displayCheckIds: ["blending_desc"] } },
          blending_uuid_str: {
            ...dc.qrcode,
            label: "beaninfo_label",
            linkPropOption: { ...dc.qrcode.linkPropOption, linkButtonTitle: "link", linkButtonNewTab: false },
            linkOption: { pathname: "/cafe/coffeebean/beaninfo/" },
          },
          blending_uuid: {
            fieldId: "blending_uuid_str",
            label: "product_serial",
            inputType: "display",
            valueClassName: "font-bold",
          },
          blending_desc: {
            ...dc.textAreaU,
            labelUse: false,
            valueStyle: { gridColumn: "1 / span 2" },
            display: "notNull",
          },

          ...qcCommonCols(
            form,
            formFunction?.current,
            dataFunction?.current,
            params?.locale,
            [params?.locale === enLocale ? "blending_name" : "blending_name_locale"],
            alertContext,
            ta,
          ),
        },
        listColLinkField: ["blending_result_uuid"],
        base64Field: ["blending_result_uuid"],
        // dataReloadButton: false,
        undoButton: false,
        cancelButton: false,
        removeButton: false,
      };

    default:
      return undefined;
  }
};
